import {Fragment, useState, memo, useEffect} from "react";
import pxToRem from "hooks/usePxToRem";

import {Box, Divider, Stack} from "@mui/material";
import {Grid} from "@mui/system";

import {
  BasicRateInfo,
  ModalComposition,
  Payment,
  Receipt,
  TaxesListing,
} from "./components";
import {DefaultCardStructure} from "components";
import {useFormContext} from "react-hook-form";
import {format} from "date-fns";
import {getDateMinusTimezone} from "util/getISODate";
import {Charge} from "views/ProcessDetails/refactor/types/charges.types";

const ProcessTaxes = () => {
  const [isModalCompositionOpen, setIsModalCompositionOpen] = useState(false);

  const handleOpenModalComposition = () => setIsModalCompositionOpen(true);
  const handleCloseModalComposition = () => setIsModalCompositionOpen(false);

  const {getValues, setValue} = useFormContext();
  const processCharges = getValues("processCharges") ?? [];

  const [selectedChargeId, setSelectedChargeId] = useState<number | undefined>(
    processCharges[0]?.id,
  );

  const formatToDecimal = (value: number) => {
    return Number(value).toFixed(2);
  };

  const getTableData = (charges: Charge[] = []) => {
    const result = charges.map((charge) => ({
      id: charge.id,
      idKnowledgeHouse: charge.idKnowledgeHouse,
      rate: charge.displayCharge?.name,
      equipment: charge.equipment?.name,
      displayCharge: charge.displayCharge?.name,
      originCharge: charge.originCharge,
      dateExpiry: charge.dateExpiry
        ? format(getDateMinusTimezone(charge.dateExpiry), "yyyy-MM-dd")
        : "",
      modalityPayment: charge.modalityPayment,
      payTo: charge.payTo,
      typeService: charge.typeService,
      paymentPerson: charge.paymentPerson?.name,
      paymentCurrency: charge.paymentCurrency?.abbreviation,
      typePayment: charge.typePayment,
      billingPayment: charge.billingPayment,
      quantityPayment: formatToDecimal(charge.quantityPayment),
      valuePaymentUnit: formatToDecimal(charge.valuePaymentUnit),
      valuePaymentMinimum: formatToDecimal(charge.valuePaymentMinimum),
      valuePaymentTotal: formatToDecimal(charge.valuePaymentTotal),
      valueReceiptUnit: formatToDecimal(charge.valueReceiptUnit),
      valueReceiptMinimum: formatToDecimal(charge.valueReceiptMinimum),
      valueReceiptTotal: formatToDecimal(charge.valueReceiptTotal),
      receiptPerson: charge.receiptPerson?.name,
      receiptCurrency: charge.receiptCurrency?.abbreviation,
      typeReceipt: charge.typeReceipt,
      receiveFrom: charge.receiveFrom,
      quantityReceipt: formatToDecimal(charge.quantityReceipt),
      modalityReceipt: charge.modalityReceipt,
    }));
    return result;
  };

  useEffect(() => {
    setValue(
      "charges",
      getTableData(getValues("processCharges") ?? []).find(
        (item) => item?.id === selectedChargeId,
      ),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedChargeId]);

  return (
    <Fragment>
      <ModalComposition
        isModalOpen={isModalCompositionOpen}
        onRequestCloseModal={handleCloseModalComposition}
      />

      <DefaultCardStructure
        title="Taxas"
        linkId="taxes"
        hasDivider={false}
        titleMarginBottom={5}
        sx={{mt: pxToRem(30)}}
      >
        <Stack sx={{gap: pxToRem(10)}}>
          <TaxesListing
            onRequestOpenModalComposition={handleOpenModalComposition}
            setSelectedChargeId={setSelectedChargeId}
            getTableData={getTableData}
          />

          <BasicRateInfo />
        </Stack>
      </DefaultCardStructure>

      <Grid
        container
        display="grid"
        gridTemplateColumns="1fr auto 1fr"
        gap={pxToRem(10)}
        mt={pxToRem(10)}
      >
        <Grid>
          <Payment />
        </Grid>

        <Grid alignSelf="flex-end">
          <Divider orientation="vertical" sx={{height: "98%"}} />
        </Grid>

        <Grid>
          <Receipt />
        </Grid>
      </Grid>

      <Box mt={pxToRem(24)}>
        <Divider />
      </Box>
    </Fragment>
  );
};

export default memo(ProcessTaxes);
